/**
 * A replacement for lodash.get, as it is now deprecated. Traverse an object using a string as the path
 * Useful for cases where the object is not available when the path to traverse is written (ie path is written in an env file for an object known to exist at runtime)
 * If the path is being written when the object is available, use optional chaining instead, since it will be much faster
 * @example 
 * // returns 3
 * const myObj = { firstProperty: [{"i am": "index 0"}, [ { value: 3} ]] }
 * get(myObj, 'firstProperty[1][0].value')
 * @param {Object} object - The object to traverse.
 * @param {string} path - The dot-separated path string specifying the property to retrieve.
 * @returns {*} - The value at the specified path, or undefined if the path does not exist.
 */
export default function get(object, path) {
  if (typeof object !== 'object' || object === null) return undefined
  if (path === '' || path === null || path === undefined) return object
  if (typeof path !== 'string') return undefined
  const regex = /([^.\[\]]+)|\[(\d+|(?:"((?:[^"]|\\")*)"))\]/gm
  const pathParts = []
  let match
  while ((match = regex.exec(path)) !== null) {
    pathParts.push(match.findLast(v => v)); // Push the matched group (either the key or the index)
  }
  let current = object
  for (const part of pathParts) {
    let asNum
    if (Array.isArray(current) && !Number.isNaN(asNum = Number(part))) {
      current = current[asNum]
    } else if (current?.hasOwnProperty(part)) {
      current = current[part]
    } else {
      return undefined
    }
  }
  return current
}
